'use client';

/**
 * Search Component - Exactly like Vercel Commerce
 */

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useSearchParams, useRouter } from 'next/navigation';
import { useThemePath } from '@/themes/core/hooks';
import { useState } from 'react';

interface SearchProps {
    direction?: "auto" | "rtl" | "ltr";
    placeholder?: string;
}

export default function Search({ direction = "auto", placeholder }: SearchProps) {
    const searchParams = useSearchParams();
    const router = useRouter();
    const { searchLink } = useThemePath();
    const [query, setQuery] = useState(searchParams?.get('q') || '');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (query.trim()) {
            router.push(searchLink(query));
        }
    };

    // Determine layout based on direction
    // If LTR: Typing starts Left -> Icon should be Right (Opposite)
    // If RTL (or auto): Typing starts Right -> Icon should be Left (Opposite)
    const isLtr = direction === 'ltr';

    return (
        <form onSubmit={handleSubmit} className="w-max-[550px] relative w-full lg:w-80 xl:w-full">
            <label htmlFor="store-search" className="sr-only">البحث عن منتجات</label>
            <input
                type="search"
                id="store-search"
                name="q"
                placeholder={placeholder || "البحث عن منتجات..."}
                autoComplete="off"
                aria-label={placeholder || "البحث عن منتجات"}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className={`text-md w-full rounded-lg border border-border bg-background px-4 py-2 text-foreground placeholder:text-muted-foreground md:text-sm ${isLtr ? 'pr-10 text-left' : 'pl-10 text-right'
                    }`}
            />
            <div className={`absolute top-0 flex h-full items-center ${isLtr ? 'right-0 mr-3' : 'left-0 ml-3'
                }`}>
                <MagnifyingGlassIcon className="h-4" />
            </div>
        </form>
    );
}

export function SearchSkeleton() {
    return (
        <form className="w-max-[550px] relative w-full lg:w-80 xl:w-full">
            <label htmlFor="store-search-skeleton" className="sr-only">البحث عن منتجات</label>
            <input
                id="store-search-skeleton"
                placeholder="البحث عن منتجات..."
                aria-label="البحث عن منتجات"
                className="w-full rounded-lg border border-border bg-background px-4 py-2 text-sm text-foreground placeholder:text-muted-foreground"
            />
            <div className="absolute left-0 top-0 ml-3 flex h-full items-center">
                <MagnifyingGlassIcon className="h-4" />
            </div>
        </form>
    );
}
